export type BrowserRuntimeConfig = {
  apiUrl?: string;
  sentryDsn?: string;
  environment?: string;
};

export type BrowserSentryOptions = {
  dsn: string;
  environment: string;
  tracesSampleRate: number;
};

declare global {
  var __INSIGHTS_RUNTIME_CONFIG__: BrowserRuntimeConfig | undefined;
}

function optionalString(
  value: Record<string, unknown>,
  key: keyof BrowserRuntimeConfig,
): string | undefined {
  const candidate = value[key];

  if (typeof candidate !== "string") {
    return undefined;
  }

  const normalized = candidate.trim();

  return normalized || undefined;
}

export function readBrowserRuntimeConfig(
  value: unknown = globalThis.__INSIGHTS_RUNTIME_CONFIG__,
): BrowserRuntimeConfig {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }

  const record = value as Record<string, unknown>;
  const config: BrowserRuntimeConfig = {};
  const apiUrl = optionalString(record, "apiUrl");
  const sentryDsn = optionalString(record, "sentryDsn");
  const environment = optionalString(record, "environment");

  if (apiUrl) {
    config.apiUrl = apiUrl;
  }
  if (sentryDsn) {
    config.sentryDsn = sentryDsn;
  }
  if (environment) {
    config.environment = environment;
  }

  return config;
}

export function createBrowserSentryOptions(
  config: BrowserRuntimeConfig,
): BrowserSentryOptions | undefined {
  if (!config.sentryDsn) {
    return undefined;
  }

  return {
    dsn: config.sentryDsn,
    environment: config.environment ?? "development",
    tracesSampleRate: 0.1,
  };
}

export const browserRuntimeConfig = readBrowserRuntimeConfig();
